import React, { useState, useEffect } from 'react';
import './ImpactHeader.scss';
import { Button } from '@mui/material';
import { NavLink, useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import img from '../../assets/images/pi.svg';
import logo from "./oktobizLogo.png"

const ImpactHeader = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const name = sessionStorage.getItem("bb_fullName");
    const firstName = name ? name.split(" ")[0] : "User";
    let role = sessionStorage.getItem('bb_role');

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 467);
    const [showMenu, setShowMenu] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 467);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLogout = () => {
        sessionStorage.clear();
        navigate('/');
    };

    const myFunction = () => {
        setShowMenu(!showMenu);
        document.body.classList.toggle("no-scroll");
    };

    const getHeaderContent = () => {
        if (location.pathname === "/table") {
            return {
                title: "Business Registration List",
                subtitle: "Manage and review all registered applications"
            };
        }

        if (location.pathname === "/transactions_list") {
            return {
                title: "Transactions",
                subtitle: "Track payment and activity records"
            };
        }

        if (location.pathname.startsWith("/details/")) {
            return {
                title: "Application Details",
                subtitle: "Review registration information and status"
            };
        }

        return {
            title: "Dashboard",
            subtitle: "Admin Workspace"
        };
    };

    const headerContent = getHeaderContent();

    return (
        <div className="impact-header-container">
            <div className="header-left-pane">
                {isMobile && (
                    <>
                        <div className={`toggle_menu ${showMenu ? "actives" : ""}`}>
                            <div className='headingparent'>
                                <div className='heading'>
                                    {/* <h1>BetterBusiness</h1> */}
                                    <img src={logo} alt="oktobiz_logo" />
                                </div>
                            </div>
                            <div className="menus">
                                <ul className="navbar_nav">
                                    <li>{role === 'admin' ? <NavLink onClick={myFunction} to="/home">Dashboard</NavLink> : null}</li>
                                    <li><NavLink onClick={myFunction} to="/table" style={{ fontWeight: "800" }}>Registered Business</NavLink></li>
                                    <li><NavLink onClick={handleLogout} to="/">Logout</NavLink></li>
                                </ul>
                            </div>
                        </div>
                        <div className="toggle_button">
                            <button
                                onClick={myFunction}
                                className={showMenu ? "menuicons" : ""}
                            >
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                    </>
                )}
                <div className='flex flex-col justify-center'>
                    <h1 className='text-[18px] font-semibold text-slate-800 tracking-tight leading-tight m-0'>{headerContent.title}</h1>
                    <span className='text-[12px] text-slate-500 font-normal leading-normal mt-0.5'>{headerContent.subtitle}</span>
                </div>
            </div>
            <div className="header-right-pane">
                <IconButton sx={{ p: 0 }} className='impact-user-card'>
                    <CardHeader
                        avatar={
                            <Avatar aria-label="recipe" src={img} className='avatar'></Avatar>
                        }
                        title={firstName}
                        subheader={role === 'admin' ? "Administrator" : "Team Member"}
                    />
                    <ExpandMoreIcon fontSize="medium" color="primary"></ExpandMoreIcon>
                </IconButton>
            </div>
        </div>
    )
}

export default ImpactHeader;
